import { render, staticRenderFns } from "./BusinessOnboarding.vue?vue&type=template&id=dd569c36&scoped=true&"
import script from "./BusinessOnboarding.vue?vue&type=script&lang=ts&"
export * from "./BusinessOnboarding.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessOnboarding.vue?vue&type=style&index=0&id=dd569c36&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd569c36",
  null
  
)

export default component.exports